import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homenine-features',
  templateUrl: './homenine-features.component.html',
  styleUrls: ['./homenine-features.component.scss']
})
export class HomenineFeaturesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
